import { Request } from '@/utils/request';

import type { CommonResponse } from './utils';

interface IParam {
  sessionId: string;
}

function updateSummary(data: IParam) {
  return Request<CommonResponse<any>>({
    url: '/rest/general/session/close',
    method: 'post',
    data
  });
}

export default updateSummary;
